import { DataTypes } from "@lexriver/data-types"

export enum EnumDisplayPrice{
    Hidden = 'hidden',
    RetailOnly = 'retail-only',
    WholesaleOnly = 'wholesale-only',
    WholesaleAndRetail = 'wholesale-and-retail'

}

export function convertStringToEnumDisplayPrice(x:string|undefined, defaultValue:EnumDisplayPrice){
    if(DataTypes.isValueExistsInEnum(x, EnumDisplayPrice)){
        return x as EnumDisplayPrice
    }
    return defaultValue
}

export function getDislayNameByEnumDisplayPrice(displayPrice?:EnumDisplayPrice){
    if(!displayPrice) return '?'
    switch(displayPrice){
        case EnumDisplayPrice.Hidden: return 'скрыт'
        case EnumDisplayPrice.RetailOnly: return 'только розн'
        case EnumDisplayPrice.WholesaleAndRetail: return 'опт и розн'
        case EnumDisplayPrice.WholesaleOnly: return 'только опт'
    }
}
